import React from 'react';
import moment from 'moment';
import { formatPhoneNumberIntl } from 'react-phone-number-input';

import { Logo, MCButton, Spinner } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import { TableLibrary } from 'src/components/complex';
import cardModel from 'src/components/paymentCard/model';
import LANG_CONST from 'src/helpers/lang/const';

import { lang, userFullName, number, remCss, permissions, addressObject } from 'src/helpers';

import model from './model';

class DetailInvoice extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      item: null
    };
  }

  componentDidMount() {
    this.setState({ item: null });
    model.baseSubscribe(this.subscription);
    cardModel.subscribe(this.subscription);

    model.loadDetail(this.props.item.id, (err, data) => {
      !err && this.setState({ item: data });
    });
    window.addEventListener('afterprint', this.afterprint);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    cardModel.unsubscribe(this.subscription);
    window.removeEventListener('afterprint', this.afterprint);
  }

  afterprint = () => {
    this.setState({ printing: false });
  };

  renderBody = () => {
    const { item } = this.state;
    const { user } = model.state;

    const patient = user.id === item.patientId ? user : item.patient;
    const doctor = user.id === item.userId ? user : item.doctor;

    const card = item.status === 'paid' ? item.card : null;

    const scale = this.props.screenDetail.isSmallScreen ? 0.7 : 1;

    return (
      <div className='mc-modal-body mc-flex-20-col'>
        <div className={'mc-flex mc-mb10'}>
          <div className='mc-grow mc-value-636'>{lang.t(LANG_CONST.titles.invoice)}</div>
          <Logo
            logoProps={{ width: 60 * scale, height: 60 * scale }}
            titleProps={{ style: { fontSize: 48 * scale } }}
          />
        </div>
        <div className='mc-flex-5-col'>
          <div className='mc-value-520'>{lang.t(LANG_CONST.serie) + ': ' + (item.serie || '')}</div>
          <div className='mc-value-520'>
            {lang.t(LANG_CONST.invoice_no) + ': ' + item.invoiceNo}
          </div>
          <div className='mc-value-520'>
            {lang.t(LANG_CONST.date) +
              ': ' +
              moment(
                item.invoiceDate,
                item.invoiceDate.toString().length === 8 ? 'YYYYMMDD' : ''
              ).format('DD/MM/YYYY')}
          </div>
        </div>
        <div className={'mc-flex mc-wrap'}>
          <div className='mc-grow mc-flex-10-col' style={{ minWidth: 300 }}>
            <div className='mc-value-624'>{lang.t(LANG_CONST.billing_to)}:</div>
            <div className='mc-value-622'>{userFullName(patient)}</div>
            <div>
              <div className='mc-value-418'>
                {formatPhoneNumberIntl(patient.phoneNumber.toString())}
              </div>
              <div className='mc-value-418'>{patient.email}</div>
            </div>
          </div>
          <div className={'mc-grow'} style={{ minWidth: 20 }} />
          <div className='mc-grow mc-flex-10-col' style={{ minWidth: 300 }}>
            <div className='mc-value-624'>{'Dr. ' + userFullName(doctor)}</div>
            <div className={'mc-value-418'}>
              {doctor.specialist
                ?.filter((v) => !!LANG_CONST.constants.specialist[v])
                .map((v) => lang.t(LANG_CONST.constants.specialist[v]))
                .join(', ')}
            </div>
            <pre className='mc-value-418'>
              {doctor.address} {addressObject(doctor).fullAddressNameReverse}
            </pre>
          </div>
        </div>
        <div style={{ marginTop: remCss(10), marginLeft: remCss(-30), marginRight: remCss(-30) }}>
          <TableLibrary
            template={2}
            showPagination={false}
            data={item.invoiceDetails}
            columns={[
              {
                label: LANG_CONST.sr,
                width: '13%',
                renderCell: (invoiceDetail, i) => String(i + 1).padStart(3, '0')
              },
              {
                label: LANG_CONST.description,
                renderCell: (invoiceDetail) => (
                  <div style={{ whiteSpace: 'normal' }}>{invoiceDetail.description}</div>
                )
              },
              {
                label: LANG_CONST.price,
                width: '15%',
                renderCell: (invoiceDetail) =>
                  `${number.format(invoiceDetail.price)} ${item.currency}`
              },
              {
                label: LANG_CONST.vat,
                width: '12%',
                renderCell: (invoiceDetail) => invoiceDetail.vat + '%'
              },
              {
                label: LANG_CONST.total,
                width: '20%',
                cellStyles: { textAlign: 'end' },
                renderCell: (invoiceDetail) =>
                  `${number.format(invoiceDetail.total)} ${item.currency}`
              }
            ]}
            footer={
              <div className={'mc-flex mc-row mc-value-522'}>
                <div className={'mc-grow'} />
                <div className={''}>{lang.t(LANG_CONST.grand_total) + ' :'}</div>
                <div style={{ maxWidth: 120, width: '100%', padding: 30, textAlign: 'right' }}>
                  {number.format(item.amount)} {item.currency}
                </div>
              </div>
            }
          />
        </div>
        {card && (
          <div className='mc-flex-5-col' style={{ marginTop: remCss(-20) }}>
            <div className='mc-value-624'>{lang.t(LANG_CONST.payment_method)}</div>
            <div className={'mc-note-522'}>{lang.t(LANG_CONST.by_online)}</div>
            <div className='mc-note-420'>{lang.t(LANG_CONST.card) + ' : ' + card.brand}</div>
            <div className='mc-note-420'>
              {lang.t(LANG_CONST.card_number) + ' : '}**** **** **** {card?.last4}
            </div>
            <div className='mc-note-420'>
              {lang.t(LANG_CONST.valid_thru) + ' : ' + String(card?.exp_month).padStart(2, '0')}/
              {card?.exp_year}
            </div>
          </div>
        )}
      </div>
    );
  };

  render() {
    const { hide, screenDetail } = this.props;
    const { item } = this.state;
    const { user } = model.state;

    if (model.getApiState('detail').loading || !item) {
      return <Spinner />;
    }

    let styleContain = screenDetail.isSmallScreen ? {} : { width: '80%', maxWidth: remCss(1400) };

    if (this.state.printing) {
      styleContain = {
        width: '100%',
        maxHeight: '100%',
        height: '100%',
        borderRadius: 0,
        maxWidth: '100%'
      };
    }

    return (
      <div className={'mc-popup-contain'} style={styleContain}>
        {this.renderBody()}
        {!this.state.printing && (
          <div className='mc-modal-footer mc-flex'>
            <div className='mc-grow' />
            <MCButton
              primary
              light
              radius
              medium
              type={'button'}
              onClick={hide}
              label={LANG_CONST.buttons.close}
            />
            {(user?.isDoctor || user?.isClinic || item.status === 'paid') && (
              <MCButton
                primary
                dark
                radius
                medium
                type={'button'}
                onClick={() => model.openPdf(item)}
                label={LANG_CONST.buttons.download}
              />
            )}
            {!user?.isDoctor && !user?.isClinic && item.status === 'unpaid' && (
              <MCButton
                primary
                dark
                radius
                medium
                type={'button'}
                onClick={() => {
                  this.navigate(permissions.PAGES.INVOICES_PAYMENT_PAGE.match(item.id));
                  hide();
                }}
                label={LANG_CONST.buttons.pay}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default DetailInvoice;
